/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { useStateValue } from "../../SharedContext";
import get from "lodash.get";
import { getTextColor, isExternalStory, getStoryUrl } from "../../../utils/utils";

import "./headline.m.css";
import { PremiumStoryIcon } from "../PremiumStoryIcon";

export const Headline = ({ story, headerLevel, premiumStoryIconConfig = {} }) => {
  const configData = useStateValue() || {};
  const { iconColor = "#F7B500", iconStyle = "star", enablePremiumStoryIcon = false } = premiumStoryIconConfig;
  const alternateHeadline = get(story, ["alternative", "home", "default", "headline"]);
  const premiumStory = enablePremiumStoryIcon && get(story, ["access"]) === "subscription";
  const headline = alternateHeadline || story.headline;
  const HeaderTag = "h" + headerLevel;

  const positionHeadline = () => {
    switch (parseInt(headerLevel)) {
      case 1:
        return "-2px";
      case 2:
        return "2px";
      case 3:
        return "4px";
      case 4:
        return "5px";
      default:
        return "6px";
    }
  };

  const textColor = getTextColor(configData.theme);
  const wrapperClass = premiumStory ? "wrapper" : "";
  const iconSize = "24px";

  return (
    <div className="arrow-component arr--headline" styleName={wrapperClass}>
      {premiumStory && (
        <PremiumStoryIcon
          width={iconSize}
          height={iconSize}
          color={iconColor}
          iconType={iconStyle}
          positionTop={positionHeadline()}
        />
      )}
      <Link href={getStoryUrl(story, `/${story.slug}`)} externalLink={isExternalStory(story)}>
        <HeaderTag styleName={`headline ${textColor}`}>{headline}</HeaderTag>
      </Link>
    </div>
  );
};

Headline.propTypes = {
  /** The Story Object from the API response */
  story: PropTypes.object.isRequired,
  /** Header tags ranging h1-h6, where h[headerLevel] */
  headerLevel: PropTypes.string,
  premiumStoryIconConfig: PropTypes.shape({
    iconColor: PropTypes.string,
    iconType: PropTypes.string,
    enablePremiumStoryIcon: PropTypes.bool
  })
};

Headline.defaultProps = {
  headerLevel: "6"
};
